import moment from "moment";

/** Normalize status/route type for shipment tracking tab eligibility. */
export const normalizeShipmentTrackingStatus = (value) =>
  String(value || "")
    .trim()
    .toLowerCase()
    .replace(/[\s_-]+/g, "");

const SHIPMENT_TRACKING_STATUS_KEYS = new Set([
  "intransit",
  "delivered",
  "customerdeliverypending",
]);

export const isShipmentTrackingStatus = (value) =>
  SHIPMENT_TRACKING_STATUS_KEYS.has(normalizeShipmentTrackingStatus(value));

/** Shipment Tracking is only available when actual dispatch date is after this date. */
export const SHIPMENT_TRACKING_MIN_ACTUAL_DISPATCH_DATE = "2026-01-01";

/** Actual dispatch date must be strictly greater than 01-01-2026. */
export const isActualDispatchDateEligibleForShipmentTracking = (actualDispatchDate) => {
  if (!actualDispatchDate) {
    return false;
  }

  const parsed = moment(actualDispatchDate);
  return (
    parsed.isValid() &&
    parsed.isAfter(moment(SHIPMENT_TRACKING_MIN_ACTUAL_DISPATCH_DATE, "YYYY-MM-DD"), "day")
  );
};

/**
 * Shipment Tracking tab: actual dispatch date after 01-01-2026 AND
 * (channel "02", or In-transit / Delivered / Customer Delivery Pending).
 * Channel "01" is never eligible.
 */
export const isShipmentTrackingEligible = ({
  distributionChannel = null,
  routeType = "",
  orderStatus = "",
  actualDispatchDate = null,
} = {}) => {
  if (!isActualDispatchDateEligibleForShipmentTracking(actualDispatchDate)) {
    return false;
  }

  if (distributionChannel === "02") {
    return true;
  }

  if (distributionChannel === "01") {
    return false;
  }

  return (
    isShipmentTrackingStatus(routeType) || isShipmentTrackingStatus(orderStatus)
  );
};
